"use client";

// `EX-ANN01`, `EX-ANN02`: while a contest page holds something new (an
// announcement, an answered clarification), its tab title starts with the
// count, so a contestant reading a statement in another tab sees it. One call
// per page with the sum, so two alerts never fight over the title.

import { useEffect } from "react";

const TITLE_COUNT = /^\(\d+\) /;

export function useTitleCount(count: number): void {
  useEffect(() => {
    if (!count) return;
    document.title = `(${count}) ${document.title.replace(TITLE_COUNT, "")}`;
    return () => {
      document.title = document.title.replace(TITLE_COUNT, "");
    };
  }, [count]);
}
